import { FB_REQUEST_TYPES } from '../../../constants';
import { fb } from '../../client';
import { formToFbData } from '../fb/form.to.fb';

/** Отправляет заявку-контакт в FB */
export const sendContact = async (userId: string, formData: FE.FormData, additionalData: FE.FormData = {}) => {
    const fbData = formToFbData(formData) as unknown as FE.FormData;
    fb.sendRequest(FB_REQUEST_TYPES.CONTACT, fbData, { userId, ...additionalData });
};
